import React from 'react';
import PropTypes from 'prop-types';
import {RegularPanel} from './EmbededPanel.react';
import {isPanelInjected} from '../loadingLine/renderLoadingPanel.react';
import {lastPanelController, sendMessage} from './EmbededPanelController';
import {FormattedMessage, IntlShape} from 'react-intl';
import {openDialog, isOutlookPanel, setEmbededLoginToPath} from '../../outlook/dialog';
import {isExtensionUrl} from '../app/ExtensionCommunicate';

function onStorageChange(event) {
    if (event.key === "userToken") {
        lastPanelController().reloadDativery();
    }
}

export default class NotLogged extends React.Component {

    static contextTypes = {
        router: PropTypes.object,
    };

    constructor(props) {
        super(props);
    }


    componentDidMount() {
        /* listen for login (token refresh) */
        window.addEventListener('storage', onStorageChange);
    }

    componentWillUnmount() {
        window.removeEventListener('storage', onStorageChange);
    }

	login() {
		let host = location.origin;
		let path = '/login-only';

		if (isExtensionUrl(host) && window.config) {
			let extensionId = host.split('://')[1];
			host = window.config['app-url'];
			path = '/sign-in/' + extensionId + '/';
		}

		if (isOutlookPanel()) {
			if (window.chrome || window.safari) {
				openDialog(path, undefined, { width: 25, height: 30 });
			}
			else {
				openDialog(setEmbededLoginToPath('/'), undefined, { width: 25, height: 30 });
			}
		}
		else if (isPanelInjected()) {
			sendMessage({msg: 'dativeryScreenSettings', url: path});
		}
		else {
			window.open(host + path, '_blank');
		}
	}

    render() {
        return (
            <RegularPanel hideMenu typeForTest="not-logged">
				<div style={{textAlign: 'center', paddingTop: '8px'}}>
					<strong><FormattedMessage defaultMessage="You aren't logged in." id="NotLogged.explanation" /></strong><br />
					<button className="btn btn-primary" onClick={this.login} style={{marginTop: '8px'}}><i aria-hidden="true" className="fa fa-lock"></i> <FormattedMessage defaultMessage="Log in" id="NotLogged.login" /></button>
				</div>
            </RegularPanel>
        );
    }
}
